module.exports = __webpack_public_path__ + "img/arrow.64946ca5.svg";